module.exports = {
  id: 9,
  name: 'Star Jumps',
  categories: ['cardio', 'coordination', 'legs'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'beginner',
  skill: 'Coordination',
  points: 15,
  instructions:
    'Star jumps time! Jump up and spread arms and legs like a star, then bring them back together! This makes you strong and powerful!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to jump like a star? Let us build incredible coordination and power!',
    },
    {
      time: 3,
      text: 'Stand with feet together, arms at your sides!',
    },
    {
      time: 6,
      text: 'Keep your core engaged and get ready to blast off!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Jump up and spread your arms and legs wide!',
    },
    // SET 1 - 10 star jumps
    {
      time: 12,
      text: 'Perfect star position! Feet together, arms ready!',
    },
    {
      time: 15,
      text: 'Number 1! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 18,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 21,
      text: 'Number 2! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 24,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 27,
      text: 'Number 3! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 30,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 33,
      text: 'Number 4! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 36,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 39,
      text: 'Number 5! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 42,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 45,
      text: 'Number 6! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 48,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 51,
      text: 'Number 7! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 54,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 57,
      text: 'Number 8! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 60,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 63,
      text: 'Number 9! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 66,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 69,
      text: 'Number 10! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 72,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 75,
      text: 'Great job! Take a deep breath and shake out your arms and legs.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 78,
      text: 'Take a deep breath in and out, you are building incredible coordination!',
    },
    {
      time: 81,
      text: 'Shake out your arms and legs, get ready for round two!',
    },
    {
      time: 84,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 87,
      text: 'Remember to jump up and spread your arms and legs wide!',
    },
    {
      time: 90,
      text: '3, 2, 1, START! Jump up and spread your arms and legs wide!',
    },
    // SET 2 - 10 star jumps
    {
      time: 93,
      text: 'Perfect star position! Feet together, arms ready!',
    },
    {
      time: 96,
      text: 'Number 1! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 99,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 102,
      text: 'Number 2! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 105,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 108,
      text: 'Number 3! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 111,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 114,
      text: 'Number 4! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 117,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 120,
      text: 'Number 5! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 123,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 126,
      text: 'Number 6! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 129,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 132,
      text: 'Number 7! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 135,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 138,
      text: 'Number 8! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 141,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 144,
      text: 'Number 9! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 147,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 150,
      text: 'Number 10! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 153,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 156,
      text: 'Great job! Take a deep breath and shake out your arms and legs.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 159,
      text: 'Take a deep breath in and out, you are building incredible coordination!',
    },
    {
      time: 162,
      text: 'Shake out your arms and legs, get ready for round three!',
    },
    {
      time: 165,
      text: 'You are doing amazing! Ready for round three? Let us keep going!',
    },
    {
      time: 168,
      text: 'Remember to jump up and spread your arms and legs wide!',
    },
    {
      time: 171,
      text: '3, 2, 1, START! Jump up and spread your arms and legs wide!',
    },
    // SET 3 - 10 star jumps
    {
      time: 174,
      text: 'Perfect star position! Feet together, arms ready!',
    },
    {
      time: 177,
      text: 'Number 1! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 180,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 183,
      text: 'Number 2! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 186,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 189,
      text: 'Number 3! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 192,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 195,
      text: 'Number 4! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 198,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 201,
      text: 'Number 5! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 204,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 207,
      text: 'Number 6! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 210,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 213,
      text: 'Number 7! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 216,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 219,
      text: 'Number 8! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 222,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 225,
      text: 'Number 9! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 228,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 231,
      text: 'Number 10! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 234,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 237,
      text: 'Great job! Take a deep breath and shake out your arms and legs.',
    },
    // REST PERIOD 3 - 20 seconds
    {
      time: 240,
      text: 'Take a deep breath in and out, you are building incredible coordination!',
    },
    {
      time: 243,
      text: 'Shake out your arms and legs, get ready for the final round!',
    },
    {
      time: 246,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 249,
      text: 'Remember to jump up and spread your arms and legs wide!',
    },
    {
      time: 252,
      text: '3, 2, 1, START! Jump up and spread your arms and legs wide!',
    },
    // SET 4 - 10 star jumps
    {
      time: 255,
      text: 'Perfect star position! Feet together, arms ready!',
    },
    {
      time: 258,
      text: 'Number 1! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 261,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 264,
      text: 'Number 2! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 267,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 270,
      text: 'Number 3! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 273,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 276,
      text: 'Number 4! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 279,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 282,
      text: 'Number 5! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 285,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 288,
      text: 'Number 6! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 291,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 294,
      text: 'Number 7! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 297,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 300,
      text: 'Number 8! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 303,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 306,
      text: 'Number 9! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 309,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 312,
      text: 'Number 10! Jump up and spread your arms and legs wide like a star!',
    },
    {
      time: 315,
      text: 'Land softly and bring your arms and legs back together!',
    },
    {
      time: 318,
      text: 'Incredible work! You just completed all four sets!',
    },
    // COMPLETION
    {
      time: 321,
      text: 'Amazing work! You did 40 star jumps and built incredible coordination!',
    },
    {
      time: 324,
      text: 'You are getting super coordinated and powerful! You are a star jump champion!',
    },
    {
      time: 327,
      text: 'Great job, coordination champion! You are building incredible skills!',
    },
  ],
};
